import {Formik, Form} from 'formik';
import React from 'react';
import {Modal} from '../../../shared/modal/Modal';
import {Btn, CancelBtn} from '../../../shared/elements/btn/Btn.js';
import {withTranslation} from 'react-i18next';
import useCustomer from './CustomerState.js';
import errorHandler from '../../../util/errorHandler.js';
import {validatedValues, validationSchema} from './helper.js';
import AddEditCustomerModalBody from './AddEditCustomerModalBody';

function EditCustomerModal({customerId, close, reload, t}) {
    const {customer, loading, update} = useCustomer(customerId, t);

    const save = (values, options) => {
        update(validatedValues(values))
            .then(() => {
                options.setSubmitting(false);
                reload();
                close();
            })
            .catch((e) => {
                options.setSubmitting(false);
                errorHandler(e.response.data, true, t);
                reload();
                close();
            });
    };

    if (loading) return <span>{t('general.Loading')}</span>;

    return (
        <div>
            <Formik
                onSubmit={(values, options) => save(values, options)}
                validationSchema={validationSchema(t, customer)}
                initialValues={{
                    customerId: customer.customerId,
                    name: customer.name,
                    plantName: customer.plantName,
                    invoiceLogicType: customer.invoiceLogicType,
                    priceLaborSaturdaySupervisor: customer.priceLaborSaturdaySupervisor,
                    priceLaborSundayHolidaySupervisor: customer.priceLaborSundayHolidaySupervisor,
                    priceLaborSaturdayForklift: customer.priceLaborSaturdayForklift,
                    priceLaborSundayHolidayForklift: customer.priceLaborSundayHolidayForklift,
                    surchargeInHandlingSat: customer.surchargeInHandlingSat,
                    surchargeInHandlingSun: customer.surchargeInHandlingSun,
                    surchargeOutHandlingSat: customer.surchargeOutHandlingSat,
                    surchargeOutHandlingSun: customer.surchargeOutHandlingSun,
                    articleGroups: customer.articleGroups,
                    extraWorkItems: customer.extraWorkItems,
                }}
            >
                {({isSubmitting, handleSubmit, values, setFieldValue, setFieldTouched, errors, touched}) => (
                    <Form>
                        <Modal size="lg" title={t('customer.EditCustomer')}>
                            <AddEditCustomerModalBody
                                values={values}
                                setFieldValue={setFieldValue}
                                setFieldTouched={setFieldTouched}
                                errors={errors}
                                touched={touched}
                                t={t}
                            />
                            <Modal.Footer>
                                <CancelBtn type="button" color="default" onClick={close} disabled={isSubmitting}>
                                    {t('general.Cancel')}
                                </CancelBtn>
                                <Btn
                                    type="submit"
                                    onClick={() => handleSubmit()}
                                    color="success"
                                    disabled={isSubmitting}
                                >
                                    {t('general.Submit')}
                                </Btn>
                            </Modal.Footer>
                        </Modal>
                    </Form>
                )}
            </Formik>
        </div>
    );
}

export default withTranslation()(EditCustomerModal);
